import { Component, Output, EventEmitter, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { EButtonType } from "../../data-types/button.enum";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { iconsLibrary } from "../../../theme/constants";
import { UserService } from "../../services/user.service";
import { Router } from "@angular/router";
import { showAlertAction } from "../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
@Component({
  selector: "cowing-core-pwd-recovery",
  templateUrl: "./pwd-recovery.component.html",
  styleUrls: ["./pwd-recovery.component.scss"],
})
export class PwdRecoveryComponent {
  @Output("navigateLogin") goLogin = new EventEmitter();
  @Input("token") recoveryToken: string = null;
  @Input("email") email: string = null;
  public password: string = "";
  public repeatPassword: string = "";
  public error: string = "";

  public EButtonType = EButtonType;
  constructor(
    private _store: Store<IAppState>,
    private router: Router,
    private translate: TranslateService
  ) {}
  public get getLandingImage() {
    return `${iconsLibrary.landingImage}`;
  }

  public get getLandingImageMobile() {
    return `${iconsLibrary.mobileLanding}`;
  }
  public pwdRecoveryForm = new FormGroup(
    {
      newPassword: new FormControl(null, [Validators.required]),
      repeatNewPassword: new FormControl(null, [Validators.required]),
    },
    { validators: this.checkPasswords }
  );

  checkPasswords(group: FormGroup) {
    const password = group.get("newPassword").value;
    const confirmPassword = group.get("repeatNewPassword").value;

    return password === confirmPassword ? null : { notSame: true };
  }

  public get getLogoImage() {
    return `${iconsLibrary.logoMini}`;
  }

  changePwd($event) {
    this._store.dispatch(showLoadingAction({}));
    const { newPassword } = this.pwdRecoveryForm.value;
    UserService.instance
      .resetPwd(newPassword, this.email, this.recoveryToken)
      .then(() => {
        this._store.dispatch(closeLoadingAction({}));
        this._store.dispatch(
          showAlertAction({
            payload: {
              message: this.translate.instant("pwd-recovery.success"),
              title: this.translate.instant("pwd-recovery.done"),
              type: "alert",
            },
          })
        );
        this.router.navigate(["login"]);
      })
      .catch((err) => {
        this._store.dispatch(closeLoadingAction({}));
        this.error = err.data.errors[0] || err.data.error;
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                err.status === 401
                  ? this.translate.instant("general.expired")
                  : err.data.error,
              title: this.translate.instant("pwd-recovery.caution"),
              type: "error",
            },
          })
        );
      });
  }
}
